require('initializers/gettext').default(__TRANSLATIONS__.gettext.nl); // eslint-disable-line no-undef
require('initializers/i18n').default('nl', __TRANSLATIONS__.i18n.nl); // eslint-disable-line no-undef

require('locales/dependencies');

require('select2/dist/js/i18n/nl');
require('jquery-ui/ui/i18n/datepicker-nl');
require('dayjs/locale/nl');
